module.exports = __webpack_public_path__ + "img/check.cab78b18.svg";